import { c as _c } from "react/compiler-runtime";
/** A light band sweeping across whatever it covers, for work in flight. */
export function Shimmer() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-10 overflow-hidden"><div className="animate-shimmer absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}